<ui-dialog
    size="small"
    header="applicant-tracker.confirmDeleteLink"
    [open]="isDeleteLinkDialogOpen"
    deleteDialog
    (primaryButtonPressed)="deleteLink()"
    primaryButtonLabel="{{ 'delete' | appTranslate }}"
    secondaryButtonLabel="{{ 'cancel' | appTranslate }}"
    (secondaryButtonPressed)="closeDeleteLinkDialog()"
>
    <p>{{ 'applicant-tracker.areYouSureYouWantToDeleteLink' | appTranslate }}</p>
</ui-dialog>

<ui-dialog
    size="small"
    [open]="isAddAdditionalLinkDialogOpen"
    header="applicant-tracker.addLink"
    (closing)="closeAddAdditionalLinkDialog()"
>
    <form #form="ngForm" autocomplete="off">
        <div class="app-grid">
            <mat-form-field class="columns-12">
                <mat-label>{{ 'applicant-tracker.name' | appTranslate }}</mat-label>
                <input
                    matInput
                    type="text"
                    required
                    name="additionalLinkAttachmentName"
                    [(ngModel)]="additionalLinkAttachmentName"
                />
            </mat-form-field>
            <mat-form-field class="columns-12">
                <mat-label>{{ 'applicant-tracker.linkUrl' | appTranslate }}</mat-label>
                <input
                    matInput
                    type="text"
                    required
                    name="additionalLinkAttachmentContent"
                    [(ngModel)]="additionalLinkAttachmentContent"
                />
            </mat-form-field>
        </div>

        <ui-dialog-footer>
            <ui-button type="ghost" (click)="closeAddAdditionalLinkDialog()">{{ 'cancel' | appTranslate }}</ui-button>
            <ui-button
                type="primary"
                [disabled]="!additionalLinkAttachmentName || !additionalLinkAttachmentContent"
                (click)="addAdditionalLinkAttachment()"
                >{{ 'add' | appTranslate }}</ui-button
            >
        </ui-dialog-footer>
    </form>
</ui-dialog>

<ui-card [loading]="isLoading">
    <ng-container>
        <app-segment-header title="applicant-tracker.links">
            <div class="buttons margin-right-2" *ngIf="linkAttachments.length > 0 && showSaveAndCancel">
                <ui-button (click)="cancelEditMode(selectedIndex)" type="ghost">{{
                    'cancel' | appTranslate
                }}</ui-button>
                <ui-button (click)="addLink(selectedLinkAttachment, selectedIndex)" name="saveLink" type="primary">{{
                    'save' | appTranslate
                }}</ui-button>
            </div>
            <div class="buttons margin-right-2" *ngIf="!showSaveAndCancel">
                <ui-button class="add-link" name="addAdditionalLink" (click)="openAddAdditionalLinkDialog()" type="link"
                    ><mat-icon svgIcon="plus"></mat-icon> {{ 'applicant-tracker.link' | appTranslate }}</ui-button
                >
            </div>
        </app-segment-header>

        <ng-container *ngIf="linkAttachments.length === 0">{{
            'applicant-tracker.noLinks' | appTranslate
        }}</ng-container>

        <ng-container *ngIf="linkAttachments.length > 0">
            <div *ngFor="let linkAttachment of linkAttachments; let i = index">
                <div class="app-grid centered">
                    <mat-form-field *ngIf="editStates[i] === 'Add' || editStates[i] === 'Delete'" class="columns-3">
                        <mat-label>{{ linkAttachment.jobAttachment?.name }}</mat-label>
                        <input
                            #link
                            (keydown)="onFocusUpdateCancelButton(i)"
                            (blur)="onBlurUpdateCancelButton(link, i)"
                            [name]="'attachmentInput-' + i"
                            [(ngModel)]="linkAttachment.content"
                            matInput
                            type="text"
                        />
                    </mat-form-field>
                    <ng-container *ngIf="editStates[i] === 'Add'">
                        <ui-button
                            *ngIf="cancelButtonStates[i]"
                            (click)="clearAndHideCancel(linkAttachment, i)"
                            class="columns-1"
                            type="ghost"
                            >{{ 'cancel' | appTranslate }}</ui-button
                        >
                        <ui-button
                            [disabled]="!linkAttachment.content"
                            (click)="addLink(linkAttachment, i)"
                            class="columns-1"
                            type="primary"
                            name="addLink"
                            >{{ 'add' | appTranslate }}</ui-button
                        >
                    </ng-container>
                    <ng-container *ngIf="editStates[i] === 'Edit'">
                        <div class="app-grid centered margin-top-1">
                            <p class="columns-3 text-align-left">
                                {{
                                    linkAttachment.jobAttachment?.name ||
                                        linkAttachment.name ||
                                        ('applicant-tracker.linkAttachment' | appTranslate)
                                }}
                            </p>
                        </div>
                        <div class="app-grid centered margin-top-1 margin-bottom-2">
                            <a
                                uiLink
                                [href]="linkAttachment.content"
                                target="_blank"
                                class="link columns-3 text-align-left"
                                >{{ linkAttachment.content }}</a
                            >
                            <div class="columns-1 action-container">
                                <ng-container *ngIf="linkAttachment.jobAttachment || linkAttachment.name">
                                    <ui-button type="link" (click)="editMode(linkAttachment, i)" class="remove-link">{{
                                        'edit' | appTranslate
                                    }}</ui-button></ng-container
                                >
                            </div>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="editStates[i] === 'Delete'">
                        <div class="columns-4 medium-columns-5 small-columns-5 text-align-left">
                            <ui-button
                                type="ghost"
                                (click)="openDeleteLinkDialog(linkAttachment, i)"
                                class="remove-link"
                                name="deleteLink"
                                >{{ 'applicant-tracker.deleteLink' | appTranslate }}</ui-button
                            >
                            <mat-icon
                                class="margin-left-1"
                                (click)="openDeleteLinkDialog(linkAttachment, i)"
                                svgIcon="trash"
                            ></mat-icon>
                        </div>
                    </ng-container>
                </div>
            </div>
        </ng-container>
    </ng-container>
</ui-card>
